var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5372 4.55541L11.3717 3.10988C11.832 2.31273 12.8513 2.0396 13.6485 2.49984L13.9395 2.66787C14.7367 3.12811 15.0098 4.14742 14.5495 4.94458L13.715 6.39011M10.5372 4.55541L6.20744 12.0547C5.4359 13.3911 4.99689 14.9146 4.92936 16.4562V16.4562C4.90214 17.0776 5.57569 17.4934 6.11006 17.175V17.175C7.48759 16.3544 8.63181 15.1944 9.43353 13.8058L13.715 6.39011M10.5372 4.55541L13.715 6.39011",
    stroke: "#3C6FF5",
    strokeWidth: 1.66667
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit_icon.12307e04e967fee87b820fc86fb19d8f.svg";